/**
 * @generated SignedSource<<96030c83d1fef58d5eb8faf95e9ab432>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type useBuildStatusIconFragment$data = {
  readonly canceledInfo: {
    readonly timestamp: string | null;
  } | null;
  readonly detachedFromAgent: boolean | null;
  readonly failedToStart: boolean | null;
  readonly personal: boolean | null;
  readonly state: BuildState | null;
  readonly status: string | null;
  readonly user: {
    readonly rawId: number | null;
  } | null;
  readonly " $fragmentType": "useBuildStatusIconFragment";
};
export type useBuildStatusIconFragment$key = {
  readonly " $data"?: useBuildStatusIconFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBuildStatusIconFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBuildStatusIconFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "canceledInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failedToStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "personal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detachedFromAgent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "c58f82bae6fe7048a41499bed98caec6";

export default node;
